import { render, staticRenderFns } from "./Nobu2.vue?vue&type=template&id=d37eeac4&scoped=true"
import script from "./Nobu2.vue?vue&type=script&lang=js"
export * from "./Nobu2.vue?vue&type=script&lang=js"
import style0 from "./Nobu2.vue?vue&type=style&index=0&id=d37eeac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37eeac4",
  null
  
)

export default component.exports